import { render, staticRenderFns } from "./embed.vue?vue&type=template&id=23590679&scoped=true&"
import script from "./embed.vue?vue&type=script&lang=js&"
export * from "./embed.vue?vue&type=script&lang=js&"
import style0 from "./embed.vue?vue&type=style&index=0&id=23590679&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "23590679",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src3027311980/src/shiny-map/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!module.hot.data) {
      api.createRecord('23590679', component.options)
    } else {
      api.reload('23590679', component.options)
    }
    module.hot.accept("./embed.vue?vue&type=template&id=23590679&scoped=true&", function () {
      api.rerender('23590679', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/embed.vue"
export default component.exports